import { render, staticRenderFns } from "./MiniTable2.vue?vue&type=template&id=7c74c400&scoped=true&"
import script from "./MiniTable2.vue?vue&type=script&lang=ts&"
export * from "./MiniTable2.vue?vue&type=script&lang=ts&"
import style0 from "./MiniTable2.vue?vue&type=style&index=0&id=7c74c400&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c74c400",
  null
  
)

export default component.exports